import { Component } from '@angular/core';

@Component({
  selector: 'article-skeleton-loader',
  templateUrl: './article-skeleton-loader.component.html',
  standalone: false,
})
export class ArticleSkeletonLoaderComponent {}